export function InlineNotice({ type = 'info', children }: { type?: 'info' | 'success' | 'error'; children: React.ReactNode }) {
  return <div className={`inline-notice notice-${type}`}>{children}</div>
}
